import Headroom from 'headroom.js';

const header = document.querySelector('.header');

const initHeadroom = () => {
  if (!header) {
    return;
  }
  const headroom = new Headroom(header, { scroller: document.body });
  headroom.init();
};

export default initHeadroom;
